import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { CreatePartnerRequest, Partner, partnersService } from '@aslanpay/portal-common-lib';

const useCreatePartner = ({
  onSuccess,
  onError,
}: UseMutationOptions<Partner, Error, CreatePartnerRequest>) => {
  return useMutation<Partner, Error, CreatePartnerRequest>(
    (request: CreatePartnerRequest) => partnersService.createPartner(request),
    { onSuccess, onError }
  );
};

export default useCreatePartner;
